import React from 'react'

export default function MFCardHeader({children}) {
  return (
    <div className="card-headerr border-top-0 border-bottom border-secondary bg-light d-flex align-items-center px-2 py-1">
        {children}
    </div>
  )
}
